import { Shark } from "shark-mvc";
import BaseContent from "./BaseContent";

class TextContent extends BaseContent {
	static HIERARCHICAL_LEVEL_MAP = {
		0: "Non impostato",
		1: "Volume",
		2: "Copertine (1° e 4°)",
		3: "Contenuti iniziali",
		4: "Singolo capitolo",
		5: "Articolo",
		6: "Box di testo/cit",
	};

	abstract = "";
	body = "";
	hierarchicalLevel = 0;
	subtitle = "";//2048
	textBody = "";
	type = "text";

	_mainEditorField = "body";
	_discarded = false;
	_inDesignExportedGuid = "";
	_inDesignExportedStatus = 0;
	_inDesignExportedStatusLabel = "";
	_inDesignExportedStatusCSSClasses = "";
	__hierarchicalLevelLabel = "";
	__renderableRelatedContent = [];

	constructor (data) {
		super();

		if (data) {
			this.import(data);
		}
	}

	import (data, options) {
		super.import(data, options);

		this.parseBody();
		this.parseHierarchicalLevel();
		this.parseInDesignExportedStatus();
	}

	on_inDesignExportedStatusChanged () {
		this.parseInDesignExportedStatus();
	}

	parseBody () {
		// this.__bodyAbstract = this.textBody.length > 35 ? this.textBody.slice(0, 35) + "..." : this.textBody;
		const htmlStrippedBody = this.textBody.replace(/<[^>]*>/g, "");
		this.__bodyAbstract = htmlStrippedBody.length > 65 ? htmlStrippedBody.slice(0, 65) + "..." : htmlStrippedBody;
	}

	parseHierarchicalLevel () {
		this.__hierarchicalLevelLabel = TextContent.HIERARCHICAL_LEVEL_MAP[this.hierarchicalLevel] || "";
	}

	parseInDesignExportedStatus () {
		switch (this._inDesignExportedStatus) {
			case 1:
				this._inDesignExportedStatusLabel = "Da gestire";
				this._inDesignExportedStatusCSSClasses = "bg-primary text-light";
				break;
			case 2:
				this._inDesignExportedStatusLabel = "Scartato";
				this._inDesignExportedStatusCSSClasses = "bg-danger text-light";
				break;
			case 3:
				this._inDesignExportedStatusLabel = "Importato";
				this._inDesignExportedStatusCSSClasses = "bg-success text-light";
				break;
			case 4:
				this._inDesignExportedStatusLabel = "In corso";
				this._inDesignExportedStatusCSSClasses = "bg-success text-light";
				break;
		}

		this._discarded = this._inDesignExportedStatus === 2;
	}
}

Shark.registerModel("TextContent", TextContent);

export default TextContent;